import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DoctorsInfoCard from "./DoctorsInfoCard";
import axios from "axios";

// Example icons map (you can expand or replace this)
import sleepMedicineIcon from "../../assets/images/icons/sleep.png";
import painManagementIcon from "../../assets/images/icons/muscle-spasm.png";
import palliativeCareIcon from "../../assets/images/icons/social-care.png";
import internalMedicineIcon from "../../assets/images/icons/take-medicines.png";
import familyMedicineIcon from "../../assets/images/icons/medical.png";
import neonatologyIcon from "../../assets/images/icons/baby.png";
import cardiothoracicSurgeryIcon from "../../assets/images/icons/heart.png";
import vascularSurgeryIcon from "../../assets/images/icons/surgery.png";
import plasticSurgeryIcon from "../../assets/images/icons/reconstructive.png";
import entIcon from "../../assets/images/icons/head.png"; // Otolaryngology (ENT)
import anesthesiologyIcon from "../../assets/images/icons/anesthesiology.png";

import geriatricsIcon from "../../assets/images/icons/geriatrics.png";
import physicalMedicineIcon from "../../assets/images/icons/medicine2.png";
import allergyImmunologyIcon from "../../assets/images/icons/allergy.png";
import infectiousDiseasesIcon from "../../assets/images/icons/coronavirus.png";
import rheumatologyIcon from "../../assets/images/icons/rheumatology.png";
import hematologyIcon from "../../assets/images/icons/blood-drop.png";
import radiologyIcon from "../../assets/images/icons/radiology.png";
import urologyIcon from "../../assets/images/icons/urology.png";
import orthopaedicsIcon from "../../assets/images/icons/trabecular.png";
import pulmonologyIcon from "../../assets/images/icons/pulmonology.png";
import emergencyMedicinesIcon from "../../assets/images/icons/medicine.png";
import nephrologyIcon from "../../assets/images/icons/nephrology.png";
import psychiatryIcon from "../../assets/images/icons/psychiatry.png";
import gynecologyIcon from "../../assets/images/icons/gynecology.png";
import dermatologyIcon from "../../assets/images/icons/dermatology.png";
import oncologyIcon from "../../assets/images/icons/oncology.png";
import neurologyIcon from "../../assets/images/icons/neuron.png";
import gastroenterologyIcon from "../../assets/images/icons/stomach.png";
import cardiologyIcon from "../../assets/images/icons/medical-checkup.png";
import endocrinologyIcon from "../../assets/images/icons/endocrinology.png";
import paediatricsIcon from "../../assets/images/icons/healthcare.png";
import ophthalmologyIcon from "../../assets/images/icons/vision-care.png";
import dentistryIcon from "../../assets/images/icons/dental-checkup.png";
import generalPracticeIcon from "../../assets/images/icons/doctors-office.png";
import hepatologyIcon from "../../assets/images/icons/hepatology.png";
import nutritionIcon from "../../assets/images/icons/nutrition.png";
import { StyledTextField } from "../doctor-console/StyledComponents";
const departmentIcons = {
  "Sleep Medicine": sleepMedicineIcon,
  "Pain Management": painManagementIcon,
  "Palliative Care": palliativeCareIcon,
  "Internal Medicine": internalMedicineIcon,
  "Family Medicine": familyMedicineIcon,
  Neonatology: neonatologyIcon,
  "Cardiothoracic Surgery": cardiothoracicSurgeryIcon,
  "Vascular Surgery": vascularSurgeryIcon,
  "Plastic Surgery": plasticSurgeryIcon,
  "Otolaryngology (ENT)": entIcon,
  Anesthesiology: anesthesiologyIcon,
  Geriatrics: geriatricsIcon,
  "Physical Medicine and Rehabilitation": physicalMedicineIcon,
  "Allergy and Immunology": allergyImmunologyIcon,
  "Infectious Diseases": infectiousDiseasesIcon,
  Rheumatology: rheumatologyIcon,
  Hematology: hematologyIcon,
  Radiology: radiologyIcon,
  Urology: urologyIcon,
  Orthopaedics: orthopaedicsIcon,
  Pulmonology: pulmonologyIcon,
  "Emergency Medicines": emergencyMedicinesIcon,
  Nephrology: nephrologyIcon,
  Psychiatry: psychiatryIcon,
  Gynecology: gynecologyIcon,
  Dermatology: dermatologyIcon,
  Oncology: oncologyIcon,
  Neurology: neurologyIcon,
  Gastroenterology: gastroenterologyIcon,
  Cardiology: cardiologyIcon,
  Endocrinology: endocrinologyIcon,
  Paediatrics: paediatricsIcon,
  Opthalmology: ophthalmologyIcon,
  Dentistry: dentistryIcon,
  "General Practice": generalPracticeIcon,
  Hepatology: hepatologyIcon,
  Nutrition: nutritionIcon,
};

const inferImageMimeFromBase64 = (base64 = "") => {
  const trimmed = (base64 || "").trim();
  // Common base64 signatures:
  // - JPEG: /9j
  // - PNG: iVBOR
  // - GIF: R0lGOD
  if (trimmed.startsWith("/9j")) return "image/jpeg";
  if (trimmed.startsWith("iVBOR")) return "image/png";
  if (trimmed.startsWith("R0lGOD")) return "image/gif";
  return "image/png";
};

const normalizeBrandingName = (name = "") =>
  String(name || "")
    .replace(/\.png$/i, "")
    .replace(/\.jpg$/i, "")
    .replace(/\.jpeg$/i, "")
    .trim();

const containerStyle = {
  width: "100%",
  bgcolor: "background.paper",
  // boxShadow: 1,
  // borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  height: "70vh",
  maxHeight: "70vh",
  overflow: "hidden",
  overflowX: "hidden",
};

// Header and footer removed for inline rendering

const DepartmentDoctorSelectorModal = ({
  onDoctorSelect,
  // setAppointmentModal,
  setOpenSlotsModal,
  selectedDoctorId,
  onClose,
}) => {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [doctorsList, setDoctorsList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchDoctor, setSearchDoctor] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [departmentBrandingIcons, setDepartmentBrandingIcons] = useState({});
  const [brandingFetched, setBrandingFetched] = useState(false);

  const authToken = sessionStorage.getItem("accessToken") || "";
  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${authToken}`,
    }),
    [authToken]
  );
  const filteredDepartments = departments.filter((dept) =>
    dept.department.toLowerCase().includes(searchQuery.toLowerCase())
  );
  console.log("onDoctorSelect", onDoctorSelect);
  const filteredDoctors = doctorsList.filter((doc) =>
    doc.name.toLowerCase().includes(searchDoctor.toLowerCase())
  );
  const handleDoctorCardClick = (doctor) => {
    setSelectedDoctor(doctor);
    if (onDoctorSelect) onDoctorSelect(doctor.doctor_id);
  };

  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
    fetchDoctors(department.department);
  };

  const fetchDepartments = useCallback(() => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`,
        { headers }
      )
      .then((res) => setDepartments(res.data.department_list || []))
      .catch((err) => {
        console.log(err);
      });
  }, [headers]);

  const fetchFacilityBrandingForDepartments = useCallback(() => {
    const payload = {
      bucket_type: "tenant",
      bucket_category: "dept",
      file_key: "",
      facility: true,
      facility_id: sessionStorage.getItem("facility_name"),
    };

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`,
        payload,
        {
          headers: {
            ...headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res?.data?.status === "Success" && Array.isArray(res?.data?.data)) {
          const brandingMap = res.data.data.reduce((acc, item) => {
            if (!item?.name || !item?.content) return acc;
            const key = normalizeBrandingName(item.name);
            const mime = inferImageMimeFromBase64(item.content);
            acc[key] = `data:${mime};base64,${item.content}`;
            return acc;
          }, {});
          setDepartmentBrandingIcons(brandingMap);
        }
      })
      .catch((err) => console.error("Error fetching facility branding", err))
      .finally(() => setBrandingFetched(true));
  }, [headers]);

  const fetchDoctors = (department) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_doctors_based_on_department/`,
        { department },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          },
        }
      )
      .then((res) => setDoctorsList(res.data.response_list || []))
      .catch((err) => console.error("Error fetching doctors", err));
  };

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  useEffect(() => {
    // Fetch branding when any of the departments do not have a predefined icon mapping.
    if (!departments?.length || brandingFetched) return;
    const anyDepartmentMissingIcon = departments.some(
      (dept) => !departmentIcons?.[dept?.department]
    );
    if (anyDepartmentMissingIcon) {
      fetchFacilityBrandingForDepartments();
    } else {
      setBrandingFetched(true);
    }
  }, [departments, brandingFetched, fetchFacilityBrandingForDepartments]);

  return (
    <Box sx={containerStyle}>
      {/* Scrollable Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          overflow: "hidden",
          height: "100%",
          minHeight: 0,
          p: 2,
        }}
      >
        {/* Left Scrollable Section */}
        <Box
          sx={{
            width: { xs: "100%", sm: "35%", md: "30%" },
            height: "100%",
            borderRight: { xs: "none", sm: "1px solid #eee" },
            borderBottom: { xs: "1px solid #eee", sm: "none" },
            overflowY: "auto",
            p: { xs: 1, sm: 2 },
            flexShrink: 0,
            minHeight: 0,
            WebkitOverflowScrolling: "touch",
          }}
        >
          <StyledTextField
            placeholder="Search Departments"
            fullWidth
            size="small"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{ mr: 1, fontSize: { xs: "1rem", sm: "1.2rem" } }}
                />
              ),
            }}
            sx={{
              mb: { xs: 1, sm: 2 },
              "& .MuiInputBase-input": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
            }}
          />
          {/* <Grid container spacing={2}>
              {filteredDepartments.map((dept, index) => (
                <Grid item xs={6} key={index}>
                  <IconButton
                    onClick={() => handleDepartmentClick(dept)}
                    sx={{
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      border:
                        selectedDepartment?.department === dept.department
                          ? "2px solid #21cdc0"
                          : "1px solid #ccc",
                      borderRadius: 2,
                      width: 120, // Fixed width
                      height: 90, // Fixed height
                      mx: "auto",
                      p: 1,
                      textAlign: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={departmentIcons[dept.department] || cardiologyIcon}
                      alt={dept.department}
                      style={{ width: 40, height: 40 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        textAlign: "center",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontSize: "12px", // Optional: smaller font for longer names
                        lineHeight: "14px",
                      }}
                    >
                      {dept.department}
                    </Typography>
                  </IconButton>
                </Grid>
              ))}
            </Grid> */}
          <Grid container spacing={{ xs: 1, sm: 2 }}>
            {filteredDepartments.length > 0 ? (
              filteredDepartments.map((dept, index) => (
                <Grid item xs={6} sm={6} md={6} key={index}>
                  <IconButton
                    onClick={() => handleDepartmentClick(dept)}
                    sx={{
                      backgroundColor: "#EBFAF9",
                      "&:hover": {
                        backgroundColor: "#EBFAF9",
                      },
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      border:
                        selectedDepartment?.department === dept.department
                          ? "2px solid #21cdc0"
                          : "1px solid #21cdc0",
                      borderRadius: 2,
                      width: { xs: "100%", sm: "100%" },
                      height: { xs: 56, sm: 76 },
                      mx: "auto",
                      p: { xs: 0.5, sm: 1 },
                      textAlign: "center",
                      overflow: "hidden",
                      minWidth: { xs: 0, sm: 0 },
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        departmentBrandingIcons?.[dept.department] ||
                        departmentIcons?.[dept.department] ||
                        cardiologyIcon
                      }
                      alt={dept.department}
                      sx={{
                        width: { xs: 24, sm: 32 },
                        height: { xs: 24, sm: 32 },
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        mt: { xs: 0.5, sm: 1 },
                        textAlign: "center",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        fontSize: { xs: "9px", sm: "11px" },
                        lineHeight: { xs: "11px", sm: "13px" },
                        px: 0.5,
                      }}
                    >
                      {dept.department}
                    </Typography>
                  </IconButton>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="center"
                  sx={{ mt: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  No department found.
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>

        {/* Right Scrollable Section */}
        <Box
          sx={{
            width: { xs: "100%", sm: "65%", md: "70%" },
            height: "100%",
            overflowY: "auto",
            p: { xs: 1, sm: 2 },
            flex: 1,
            minHeight: 0,
            WebkitOverflowScrolling: "touch",
          }}
        >
          {selectedDepartment ? (
            <>
              <StyledTextField
                placeholder="Search Doctors"
                fullWidth
                size="small"
                variant="outlined"
                value={searchDoctor}
                onChange={(e) => setSearchDoctor(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <SearchIcon
                      sx={{ mr: 1, fontSize: { xs: "1rem", sm: "1.2rem" } }}
                    />
                  ),
                }}
                sx={{
                  mb: { xs: 1, sm: 2 },
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              />
              <Grid container spacing={{ xs: 1, sm: 2 }}>
                {filteredDoctors.length > 0 ? (
                  filteredDoctors.map((doctor, idx) => (
                    <Grid item xs={12} sm={12} md={6} lg={6} key={idx}>
                      {/* <DoctorsInfoCard
                          doctor={doctor}
                          handleViewAppointment={() =>
                            handleDoctorSelect(doctor)
                          }
                        /> */}
                      <DoctorsInfoCard
                        doctor={doctor}
                        selected={
                          selectedDoctor?.doctor_id === doctor.doctor_id
                        } // optional visual feedback
                        handleViewAppointment={() =>
                          handleDoctorCardClick(doctor)
                        }
                      />
                    </Grid>
                  ))
                ) : (
                  // Match empty-state design used in AppointmentListPanel
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      minHeight: "42vh",
                      color: "#6B7A90",
                      border: "1px dashed #C8D0D9",
                      borderRadius: "10px",
                      p: 4,
                    }}
                  >
                    <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
                      No doctors found in this department.
                    </Typography>
                  </Box>
                )}
              </Grid>
            </>
          ) : (
            // Match empty-state design used in AppointmentListPanel
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                minHeight: "42vh",
                color: "#6B7A90",
                border: "1px dashed #C8D0D9",
                borderRadius: "10px",
                p: 4,
              }}
            >
              <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
                Select a department to view doctors
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Footer removed in inline mode */}
    </Box>
  );
};

export default DepartmentDoctorSelectorModal;
